import { render } from "./Campaign.vue?vue&type=template&id=fe7575ae&scoped=true"
import script from "./Campaign.vue?vue&type=script&setup=true&lang=js"
export * from "./Campaign.vue?vue&type=script&setup=true&lang=js"

import "./Campaign.vue?vue&type=style&index=0&id=fe7575ae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7575ae"],['__file',"resources/js/components/whatsapp-managment/includes/types/Campaign.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe7575ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe7575ae', __exports__)) {
    console.log('reload')
    api.reload('fe7575ae', __exports__)
  }
  
  module.hot.accept("./Campaign.vue?vue&type=template&id=fe7575ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('fe7575ae', render)
  })

}


export default __exports__